import { plusIcon } from "../config/icons";

const PlusIcon = ({ onClick, hidden, size = "md" }) => {
  if (hidden) return null;

  // Size variants
  const sizeStyles = {
    sm: {
      button: "p-1.5",
      icon: "w-5 h-5", // 20px
    },
    md: {
      button: "p-2",
      icon: "w-6 h-6", // 24px
    },
    lg: {
      button: "p-2.5",
      icon: "w-7 h-7", // 28px
    },
  };

  return (
    <button
      className={`
        btn-status btn-edit 
        ${sizeStyles[size].button}
        hover:scale-105 active:scale-95 
        transition-transform duration-200
      `}
      type="button"
      onClick={onClick}
      aria-label="Add item"
    >
      <img src={plusIcon} className={sizeStyles[size].icon} alt="Add" aria-hidden="true" />
    </button>
  );
};

export default PlusIcon;
